import type { InputProps } from '../input-props'
import { JalaliDatePicker } from './jalali-date-picker'

export function DateInput({ field, value, onChange, onBlur, disabled, invalid }: InputProps) {
  const calendarMode = (field.type_config?.calendar_mode as 'jalali' | 'gregorian' | undefined) ?? 'jalali'
  return (
    <JalaliDatePicker
      mode="date"
      calendarMode={calendarMode}
      value={(value as string) ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      invalid={invalid}
    />
  )
}
